import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { FooterView } from "../elements/FooterView";

// eslint-disable-next-line import/no-unused-modules
export const FooterFragment = graphql`
  fragment Footer on GraphCMS_Footer {
    id
    contactInformation {
      ...ContactInformation
    }
    externalLinkSelection {
      id
      title
      externalLinks {
        ...ExternalLink
      }
    }
    footerContactForm {
      id
      name
      controlInformation
    }
  }
`;

export const Footer: React.FC = () => {
  const data = useStaticQuery<Queries.AllFooterQuery>(graphql`
    query AllFooter {
      allGraphCmsFooter(limit: 1) {
        edges {
          node {
            ...Footer
          }
        }
      }
    }
  `);
  const footers = data?.allGraphCmsFooter?.edges;
  const firstFooter = footers?.length > 0 ? footers[0] : null;
  if (!firstFooter) return null;
  return <FooterView footer={firstFooter.node} />;
};
